import { Card, Layout } from 'antd';
import LayoutPublicHeader from '@/layouts/PublicLayout/components/PublicHeader';
import ActivationContent from './components/ActivationContent';
import ActivationHashPageProvider from './ActivationHashPage.context';

import './styles.less';

export default function ActivationHashPage() {
  return (
    <ActivationHashPageProvider>
      <Layout className="activation-hash-page">
        <LayoutPublicHeader />

        <Layout.Content className="activation-hash-page__content">
          <Card className="activation-hash-page__card">
            <ActivationContent />
          </Card>
        </Layout.Content>
      </Layout>
    </ActivationHashPageProvider>
  );
}
